import { create } from 'zustand';

type MenuType = 'catalog' | 'teahouse';

interface MenuState {
  isOpen: boolean;
  menuType: MenuType;
  open: (type?: MenuType) => void;
  openCatalog: () => void;
  openTeaHouse: () => void;
  close: () => void;
  toggle: () => void;
  toggleCatalog: () => void;
}

export const useMenuStore = create<MenuState>((set) => ({
  isOpen: false,
  menuType: 'catalog',
  open: (type = 'catalog') => set({ isOpen: true, menuType: type }),
  openCatalog: () => set({ isOpen: true, menuType: 'catalog' }),
  openTeaHouse: () => set({ isOpen: true, menuType: 'teahouse' }),
  close: () => set({ isOpen: false }),
  toggle: () =>
    set((state) => ({
      isOpen: !state.isOpen,
      menuType: state.menuType ?? 'catalog',
    })),
  toggleCatalog: () =>
    set((state) => ({
      isOpen: state.menuType === 'catalog' ? !state.isOpen : true,
      menuType: 'catalog',
    })),
}));
